<template>
  <gj-select
      v-bind="$attrs"
      v-on="$listeners"
      select-all-node
      :show-checkbox="multiple"
      :multiple="multiple"
      :type="multiple ? 'multi-check' :'default'"
      :options="operationStateReverse">
  </gj-select>
</template>

<script>
  import {mapGetters} from "vuex";
  import {isMeaningful, isMeaningless} from "../../utils/common";
  import {SALE_GET_OPERATION_STATE} from "../../store/action-types";

  export default {
    name: "gj-operation-state-select",
    props: {
      multiple: {
        type: Boolean,
        default: false
      },
    },
    computed: {
      ...mapGetters(['operationState']),
      operationStateReverse() {
        if (isMeaningful(this.operationState)) {
          const tmp = [...this.operationState];
          return tmp.reverse();
        }
        return [];
      }
    },
    data(){
      return {
        // operationStataValue: []
      }
    },
    created() {
      if (isMeaningless(this.operationState)) {
        this.$store.dispatch(SALE_GET_OPERATION_STATE);
      }
    }
  }
</script>

<style scoped>

</style>
